import frontImgForDark from "./frontendPink.png";
import frontImgForWhite from "./frontendBlue.png";
import backImgForDark from "./databasePink.png";
import backImgForWhite from "./databaseBlue.png";
import connectionImgForDark from "./connectionPink.png";
import connectionImgForWhite from "./connectionBlue.png";
import classes from "./FrontBackConnect.module.css";
import { useContext } from "react";
import { ThemeContext } from "../../App";

export default function FrontBackConnect() {

  const { theme } = useContext(ThemeContext);

  return (
    <div className={classes.frontBackConnectContainer}>
      <div id={classes[theme]} className={classes.blocks + " flex flex-wrap justify-around lg:justify-between lg:flex-nowrap items-start"}>
        <div className={classes.block + " mb-bottom-vh7 md:mb-bottom-vh12 lg:w-vw25"}>
          <div className={classes.imageBlock + " w-vw10 md:w-vw10  lg:h-vh5 lg:w-vw5 mb-bottom-vh1 md:mb-bottom-vh3 lg:mb-bottom-vh8"}>
            <img src={theme === "dark" ? frontImgForDark : frontImgForWhite} />
          </div>

          <h3 className="text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH text-center">Development of the user interface and user experience</h3>
          <p className="text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt">
            We specialize in creating user interfaces and experiences that are
            not only visually appealing, but also intuitive. Our designers
            harmoniously combine aesthetics with functionality, providing a
            pleasant and user-friendly experience for users. We approach the
            development of interfaces with a focus on highlighting unique brand
            features, creating a unique style for each project. Our interfaces
            are not only colorful, but also focused on solving specific user
            tasks, ensuring maximum satisfaction from use.
          </p>
        </div>
        <div className={classes.block + " mb-bottom-vh7 md:mb-bottom-vh12 lg:w-vw25"}>
          <div className={classes.imageBlock + " w-vw10 md:w-vw10  lg:h-vh5 lg:w-vw5 mb-bottom-vh1 md:mb-bottom-vh3 lg:mb-bottom-vh8"}>
            <img src={theme === "dark" ? connectionImgForDark : connectionImgForWhite} />
          </div>

          <h3 className="text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH text-center">Integration of the frontend and backend</h3>
          <p className="text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt">
            We ensure a harmonious interaction between the frontend and backend,
            creating a single and balanced application. Our integration
            developers are working on effective interaction of system
            components, ensuring smooth and trouble-free operation. We use
            advanced integration technologies to ensure efficient data exchange.
            Our goal is to create modern applications where the frontend and
            backend interact harmoniously, providing users with a full and
            satisfying experience.
          </p>
        </div>
        <div className={classes.block + " mb-bottom-vh7 md:mb-bottom-vh12 lg:w-vw25"}>
          <div className={classes.imageBlock + " w-vw10  md:w-vw10  lg:h-vh5 lg:w-vw5 mb-bottom-vh1 md:mb-bottom-vh3 lg:mb-bottom-vh8"}>
            <img src={theme === "dark" ? backImgForDark : backImgForWhite} />
          </div>

          <h3 className="text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH text-center">Development of the backend of applications and databases</h3>
          <p className="text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt">
            We create powerful and reliable backend solutions for applications,
            ensuring high performance and data security. Our backend development
            team specializes in using modern technologies to create effective
            applications. We not only develop, but also optimize databases,
            ensuring efficient storage and management of information. Our goal
            is to create stable and scalable solutions ready for the future
            growth of your business.
          </p>
        </div>
      </div>
    </div>
  );
}
